import React from "react";
import { Link } from "react-router-dom";
import { edit_icon } from "../icons/edit";
import { EmptyStarIcon, FullStarIcon } from "../icons/star";
import { useAuth } from "../store/authProvider";
import ConvertToArabicNumbers from "../utils/convert_numbers";

const ItemCard = ({ item, getOffer, editLink, type, favoriteOffers }) => {
  const { isAuth } = useAuth();
  return (
    <Link
      className="relative flex flex-col hover:scale-105 transition cursor-pointer items-center overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[17rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl"
      key={item.id}
      to={`/home/offers/${item.id}`}
      // onClick={() => getOffer(item.id)}
    >
      {isAuth && item.owner === localStorage.getItem("user_id") && (
        <Link to={editLink}>
          <div className="absolute right-0 text-gray-400 p-2">{edit_icon}</div>
        </Link>
      )}
      <img
        src={item?.subCategory?.image}
        className="lg:h-2/4 overflow-hidden h-32 mt-2 object-cover"
        alt=""
      />
      <div className="flex row items-center" dir="rtl">
        {/* {type === "buy" && <div className="px-2">مطلوب</div>} */}
        <div className="font-bold text-lg my-1">{item?.subCategory?.name}</div>
      </div>
      <div
        className="lg:text-lg text-md mb-0.5"
        dir="rtl"
      >{`${ConvertToArabicNumbers(item?.quantity)} ${item?._unit?.name}`}</div>
      <div className="flex row items-center" dir="rtl">
        {/* {type === "buy" && <div className="px-2">مطلوب</div>} */}
        <div className="text-sm my-1">{`سعر ال${item?._unit?.name} : ${
          item?.price_per_unit ?? "غير متوفر"
        }`}</div>
      </div>
      <div className="text-lg mb-1">{item?._state?.name}</div>
      <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">
        <div className="text-sm text-gray-400">
          قبل{" "}
          {Math.ceil(
            (new Date().getTime() - new Date(item?.created_at).getTime()) /
              86400000
          )}{" "}
          يوم
        </div>
        <div className="flex flex-row space-x-3 mb-2">
          <div className=" text-primary">
            {favoriteOffers?.map((e) => e.id).includes(item.id)
              ? FullStarIcon
              : EmptyStarIcon}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ItemCard;
